var _pacAnalytics = {};

var sessionName = "_pacAnalytics_driver";
var initialized = false;

var defaultConfig = {
  amplitude: {
    options: {
      saveEvents: true
    }
  }
};


_pacAnalytics.getConfig =function(url){ 
	var urlArray = url.split('/');
	urlArray.pop();
	var environment = urlArray.pop(); 
	var baseUrlBucket= urlArray.join('/')+"/";
	return {env:environment,baseURL:baseUrlBucket};
} 

_pacAnalytics.initialize = function (config) {
  if (!sessionStorage.getItem(sessionName)) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/app/rs/common/analyticsinfo");
    xhr.onload = function () {
      if (xhr.status === 200) {
        var result = JSON.parse(xhr.responseText);
        if (result.data) {
          sessionStorage.setItem(sessionName, result.data);
          _pacAnalytics.load(config);
        }
      }
    };
    xhr.send();
  } else {
    _pacAnalytics.load(config);
  }
};

_pacAnalytics.load = function (config) { 
  var storageURL = sessionStorage.getItem(sessionName);
  var jsonConfig = null;
  var environment = null;
  var s3base = null;
  if(storageURL){
	 jsonConfig = _pacAnalytics.getConfig(storageURL);   
  }
  if(jsonConfig){
	  environment = jsonConfig.env === "latest" ? "pus" : jsonConfig.env;
	  s3base = jsonConfig.baseURL;
  }
  if(environment && s3base)
  !function(){"use strict";var n,t,i,e,r,a,u,o=4,s=200,c=function(n){return n.map(function(n){return t=n,(e=document.createElement("script")).setAttribute("type","text/javascript"),e.setAttribute("src",t),e.onload = function () { if (config) { pacAnalytics.init(config); } else { pacAnalytics.init(defaultConfig); } console.log("initialized - driver loaded ..."); initialized = true; },e;var t,e})},d=window,p=d.document,v=d.console;d.location;n={ajax:function(n,t){var e=new XMLHttpRequest;e.onreadystatechange=function(){if(this.readyState===o)return this.status===s?t(null,JSON.parse(e.responseText)):t("Error ("+this.status+"): "+e.responseText)},e.open("GET",n,!0),e.send()},logError:function(){return(v.error||v.log).apply(void 0,arguments)},s3base:s3base,document:p,environment:environment},t=n.ajax,i=n.logError,e=n.environment,r=void 0===e?"unknown":e,a=n.s3base,u=n.document,t(a+"environments/"+r+"/manifest.json",function(n){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},e=t.version,r=t.files;if(n)return i(n);var o=a+"builds/"+e+"/",s=r.map(function(n){return o+n});c(s).map(function(n){return u.body.appendChild(n)})})}();
};

/**
 * wrap all function in this to fail gracefully
 */
function retry(fn, args, cb) {
  var tries = 3;
  var i = setInterval(function () {
    console.log("trying " + fn);
    if (initialized) {
      clearInterval(i);
      var r = pacAnalytics[fn](args);
      if (cb) cb(r);
      return r;
    } else {
      tries = tries - 1;
      if (tries === 0) {
        console.log("Could not " + fn);
        clearInterval(i);
      }
    }
  }, 500);
}

/*
 * Will send the event
 * jsonEvent = {label: "update password", eventProperties: { process: "account" } });
 */
_pacAnalytics.send = function (jsonEvent) {
  return retry("sendEvent", jsonEvent);
};

/*
 * Triggers API call to /app/rs/contexts/unified to update the user properties that are currently being sent to events
 * If the org has changed, call this before sending events to ensure properties are up to date
 * props = undefined - if the props is undefined then only reloads API and updates the generalProperties - organization id, client id, channel id, channel type
 * props = {"user id": "123456" } - if props not empty then it will reloads API and updates the generalProperties AND add the extra property you added.
 */
_pacAnalytics.updateCurrentProperties = function (props, cb) {
  retry("updateCurrentProperties", props, cb);
};

_pacAnalytics.getCurrentProperties = function (cb) {
  retry("getCurrentProperties", null, cb);
};

_pacAnalytics.initialize();

///EtWebClient:common/scripts/pa.js
